import { cn, iaRa } from 'lib/helpers/utility';

import { STEP_STATE, WIZARD_PROGRESS } from '../../lib/constants';
import { shouldRenderSubsteps } from '../../hooks/utils/stepValidation';

import SubstepRow from './SubstepRow';
import StatusBadge from './StatusBadge';
import StepDescription from './StepDescription';

const SidebarStepItem = ({
  step,
  stepIndex,
  flatStepsLength,
  nextItemType,
  prevItemType,
  sidebarType,
  hiddenSubstepCodes,
  restrictedStepsCodes,
  animatedStepCode,
  setRef,
  onExpandStep,
  onCollapseStep,
  onActivateStep,
  onNavigateSubstep
}) => {
  const isFirstStep = prevItemType === 'phase_header';
  const isFirstInList = prevItemType == null;
  const isLastStep = stepIndex === flatStepsLength - 1 || nextItemType === 'phase_header';
  const isDone =
    step.status === WIZARD_PROGRESS.COMPLETED || step.status === WIZARD_PROGRESS.CONFIRMED;
  const isInProgress = step.status === WIZARD_PROGRESS.IN_PROGRESS;
  const isRestricted = restrictedStepsCodes.has(step.code);
  const stepNumber = stepIndex + 1;

  return (
    <li
      ref={setRef}
      className={cn(
        'rounded-xl border border-solid border-transparent px-3 py-2 transition-all duration-300',
        step.state_status === STEP_STATE.EXPANDED &&
          'border border-solid border-primary-200 bg-primary-25',
        step.state_status === STEP_STATE.EXPANDED &&
          isDone &&
          'border border-solid border-success-200 bg-success-25',
        isInProgress && 'border border-solid border-warning-200 bg-warning-25',
        isRestricted && 'cursor-not-allowed bg-neutral-100',
        animatedStepCode === step.code && 'animate-pulse'
      )}>
      <div
        className={cn(
          'relative flex items-start gap-3',
          step.state_status === STEP_STATE.EXPANDED && shouldRenderSubsteps(step) && 'mb-3'
        )}>
        <StatusBadge
          step={step}
          isFirstStep={isFirstStep}
          isFirstInList={isFirstInList}
          isLastStep={isLastStep}
          stepNumber={stepNumber}
          sidebarType={sidebarType}
          onExpandStep={isRestricted ? undefined : onExpandStep}
          onCollapseStep={onCollapseStep}
          isRestricted={isRestricted}
          onActivateStep={isRestricted ? undefined : onActivateStep}
          description={
            !isDone && step.sidebar_description?.text ? (
              <StepDescription description={step.sidebar_description} isDisabled={isRestricted} />
            ) : null
          }
        />
      </div>

      {step.state_status === STEP_STATE.EXPANDED && shouldRenderSubsteps(step) && (
        <ul className="pl-0.5" aria-label="Sub-items">
          {iaRa(step?.substeps).map((sub, subIndex) => {
            const isLastSubstep = subIndex === step.substeps.length - 1;
            return (
              <SubstepRow
                key={sub.substep_id ?? sub.id ?? sub.code ?? subIndex}
                substep={sub}
                isLastSubstep={isLastSubstep}
                isLastInTree={isLastStep && isLastSubstep}
                onClick={() => onNavigateSubstep(sub.code)}
                isHidden={hiddenSubstepCodes.has(sub.code)}
                isRestricted={restrictedStepsCodes.has(sub.code)}
              />
            );
          })}
        </ul>
      )}
    </li>
  );
};

export default SidebarStepItem;
